module.exports = __webpack_public_path__ + "media/images/icons/country_flags/nr-0d87ce78609053fbd9c4f63bef208df9.svg";